import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, UserAccessDTO} from '@sollapay/types';

/**
 * API client functions for the authenticated user's resolved RBAC access
 */
export const userAccessApi = {
  /**
   * Fetch the authenticated user's resolved role, permissions, and data scopes
   */
  fetchUserAccess: async (client: HttpClient) => client.get<ApiResponse<UserAccessDTO>>('/user/me')
};
